import { render, staticRenderFns } from "./OSelect.vue?vue&type=template&id=8159f760&scoped=true&"
import script from "./OSelect.vue?vue&type=script&lang=js&"
export * from "./OSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8159f760",
  null
  
)

export default component.exports